import { Dispatch, SetStateAction } from 'react'
import { AppDispatch } from '../../Store'
import {
  FieldsToModify,
  IFieldTitleValue,
  IKeyValue,
  moduleType,
  scheduleTimeType,
} from '../CommonListHeadingModal'

export interface IContainerInstanceState {
  containerDefinitionDetails: { [key: string]: any }
  containerDetails: { [key: string]: any }
  parentContainerDetail: { [key: string]: any }
  itemDetail: { [key: string]: any[] }
  masterLayoutItemInfo: any[]
}

export const initialContainerInstanceState: IContainerInstanceState = {
  containerDefinitionDetails: {},
  containerDetails: {},
  parentContainerDetail: {},
  itemDetail: {},
  masterLayoutItemInfo: [],
}

export interface IManageContainerSlice {
  containersById: { [containerId: string]: IContainerInstanceState }
}

export interface IContainerManual {
  isFormValid?: (val: boolean) => void
  isEditableContainer?: boolean
  layoutTitle?: string
  formData?: any
  formFieldValue?: IFieldTitleValue[]
  conditionalFieldsToShow?: string[]
  isFormSaved?: boolean
  updateIsFormSaved?: (val: boolean) => void
  handleEditParameterBtnClick: () => void
  setShowSecondaryCta?: (val: boolean) => void
  setSecondaryCtaClicked?: (val: boolean) => void
  setShouldDisableSecondaryCta?: (val: boolean) => void
  secondaryCtaClicked?: boolean
  selectedTab: IKeyValue
  onJsonValidationStatusChange?: (allValidated: boolean) => void
  isLayoutScheduledOrFeatured: boolean
}
export type containerModuleType = Exclude<moduleType, 'container'>
export interface TitleFormSectionProps {
  layout: string
  pageType: string
  formContext: any
  containerFormData: any
  detailData: any
  setSelectedAssetTypes: (value: IKeyValue[]) => void
  conditionalFieldsToShow?: string[]
  fieldsToModify: FieldsToModify
  formFieldValue?: IFieldTitleValue[]
  onJsonValidationStatusChange?: (allValidated: boolean) => void
}
export interface AssetDetailsTableProps {
  module: containerModuleType
  contentListDetail: any[]
  checkedIconDisabled: boolean
  pageType: string | undefined
  layout: string
  containerDefinitionInfo: any
  replaceAndAddedItem: Set<string>
  handleAccordionDelete: (
    id: number | string,
    module: containerModuleType,
    position?: number,
  ) => void
  toggleItem: (module: containerModuleType, id: string) => void
  isItemChecked: (module: containerModuleType, id: string) => boolean
  setReplaceAndEditItemData: any
  setIsDialogOpen: any
  setModalSelectedTab: any
  imageNodesList: any[]
  dispatch: AppDispatch
  itemDetailFromRedux: any
  containerId: string | undefined
  setEditItemDetail: any
  setSelectedItemModule: any
  containerErrors: any
  setScheduleItemModal: any
  handleAdditionalParameterClick: (id: string, item: any) => void
  showFilteredList?: boolean
}
export interface ItemDetailsSectionProps {
  module: containerModuleType
  modalTabList: string[]
  layout: string
  selectedItemDetail: any
  checkedItemList: any
  pageType: string | undefined
  isItemCtaDisabled: (module: containerModuleType) => boolean
  isEditableContainer: boolean
  handleRemoveAll: (module: containerModuleType) => void
  areAllItemsChecked: any
  clearAllItems: any
  selectAllItems: any
  handleAdd: (module: containerModuleType) => void
  setShowSecondaryCta: any
  collapsedSections: Record<containerModuleType, boolean>
  setCollapsedSections: Dispatch<SetStateAction<Record<containerModuleType, boolean>>>
  visibleCount: Record<containerModuleType, number>
  displayItemToList: (module: containerModuleType, keyToCheck: string) => JSX.Element
  containerErrors: any
  handleScheduleClick: any
  itemDetailFromRedux: any
  setScheduleItemModal: any
  setSelectedItemModule: any
  isLoadingMore: any
  isPinnedSectionCollapsed: boolean
  setIsPinnedSectionCollapsed: Dispatch<SetStateAction<boolean>>
  containerModalComputedStyle: string
  layoutSegmentsList?: IKeyValue[]
  onSearchChange?: (value: string[]) => void
  onSegmentChange?: (segments: string[]) => void
  filteredWidgetList?: any[]
  showFilteredList?: boolean
}
export interface ItemDetailsRowProps extends AssetDetailsTableProps {
  item: any
  index: number
}

export interface HandleScheduleClick {
  itemLists: Record<string, any[]>
  data: Record<string, any>
  type: scheduleTimeType
  dispatch: AppDispatch
  moduleId?: string
  contentId?: number
  contentMongoId?: string
  moduleType?: 'container' | 'widget'
  setter?: Dispatch<SetStateAction<any[]>>
  updateFilteredWidgetList?: Dispatch<SetStateAction<any[]>>
}

export interface ChildContainerListingProps {
  entryPoint?: string
}
export type togglePopup = 'enable' | 'disable' | 'edit'
export interface RowSegment {
  key: number
  value: string
  segmentUrl: string
  segmentId: string
  irisSegmentStatus: string | null
  isTrayRankingEnabled: boolean
  pinCount: number
  segmentKey?: number
  isScheduled?: boolean | null
}
export type TrayRankingDialog = {
  open: boolean
  rowId: string
  enabling: togglePopup
  containerTitle: string
  containerId: string
  contentDocId: string
  rowSegments: RowSegment[]
  item: any
}
export interface GetContainerCtasList {
  isLayoutScheduledOrFeatured: boolean
  containerDefinitionDetail: any
  containerDetailData: any
}
export interface FetchWidgetSegmentFilter {
  containerId: string
  segmentSearchValue: string[]
  selectedSegmentValues: string[]
  dispatch: AppDispatch
}
